<template>
  <div>
    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <Loader v-if="loading"/>

    <HealthStatus
      :client="client"
      :elements="elements"
      :status="status"
      :userCanEdit="userCanEdit"
      v-on:show="showPresentation"
      v-on:update="updateStatus" />

    <HealthPresentation
      v-if="element && slides.length > 0"
      :element="element"
      :slides="slides"
      v-on:close="healthId = null" />
  </div>
</template>

<script>
import Flash from '../common/Flash';
import HealthStatus from './health/Status';
import HealthPresentation from './health/Presentation';
import Loader from '../common/Loader';

export default {
  name: 'Health',

  components: {Flash, HealthStatus, HealthPresentation, Loader},

  props: ['client'],

  data() {
    return {
      error: '',
      success: '',
      loading: true,
      healthId: null,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    elements() {
      return this.$store.state.health.elements;
    },

    element() {
      return this.elements.find(e => e.id === this.healthId);
    },

    content() {
      return this.$store.state.health.content;
    },

    slides() {
      const slides = [];
      const elements = [this.element];

      for (const element of this.elements) {
        if (element.parent === this.element.id) {
          elements.push(element);
        }
      }

      for (const content of this.content) {
        const element = elements.find(e => e.id === content.health);

        if (typeof element === 'undefined') {
          continue;
        }

        const mult = element.id === this.element.id ? 10 : 100;

        slides.push({
          id: content.id,
          image: content.image,
          text: content.text,
          sort: element.sort * mult + content.sort,
        });
      }

      return slides;
    },

    status() {
      const values = {};
      const state = this.$store.getters.clientHealthState(this.client.id);

      state.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());

      for (const item of state) {
        values[item.health] = item.value;
      }

      return values;
    },

    userCanEdit() {
      return this.$security.voters.health.canEdit(this.$store.state.user);
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('HEALTH_LOAD_ELEMENTS', this.client.id),
          this.$store.dispatch('HEALTH_LOAD_STATE', this.client.id),
          this.$store.dispatch('HEALTH_LOAD_CONTENT', this.client.id)
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    showPresentation(id) {
      this.healthId = id;
    },

    async updateStatus(data) {
      if (!this.userCanEdit) {
        return;
      }

      try {
        this.loading = true;

        const {health, value} = data;

        await this.$store.dispatch('HEALTH_ADD_STATE', {
          data: { user: this.client.id, values: [{health, value}] },
        });
      } catch (e) {
        this.error = `При обновлении статуса произошла ошибка: ${e.message}`;
      }

      this.loading = false;
    },
  },
};
</script>
